import { useStyles } from './styles';

export default function ProgressBar(props) {
    const classes = useStyles();
    const { completedPercentage } = props;

    return (
        <div className={classes.navigationBottomBorder}>
            <div className={classes.navigationBottomInside} style={{ width: `${completedPercentage}%` }} />
        </div>
    );
}
